<template>
  <div>
    <div class="d-flex justify-space-between">
      <h2 class="text-h5 mb-4">Etsy Products</h2>
      <v-btn color="primary" @click="fetchRealTimeProductCounts" :loading="loadingProductCounts" class="text-capitalize">
        Real-time Product Counts
      </v-btn>
    </div>

    <!-- Product Counts Modal -->
    <v-dialog v-model="productCountsDialog" max-width="600px">
      <v-card>
        <v-card-title class="headline">
          Etsy Product Counts
          <v-spacer></v-spacer>
          <v-btn icon @click="productCountsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="loadingProductCounts" class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p class="mt-2">Loading product counts...</p>
          </div>
          <div v-else>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Status</th>
                    <th class="text-right">Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(count, state) in productCounts.count_by_state" :key="state">
                    <td>{{ formatState(state) }}</td>
                    <td class="text-right">{{ count }}</td>
                  </tr>
                  <tr class="font-weight-bold">
                    <td>Total</td>
                    <td class="text-right">{{ productCounts.total_count }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- <v-card style="padding:20px"> -->
    <v-tabs v-model="tab">
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-0"> All &nbsp;<span class="primary--text" >{{product_count.all}}</span></v-tab>
      <v-tab href="#tab-1"> Linked Products  &nbsp;<span class="primary--text">{{product_count.linked_product}}</span></v-tab>
      <v-tab href="#tab-2"> SKU Linked  &nbsp;<span class="primary--text">{{product_count.linked_sku}}</span></v-tab>

      <v-tab href="#tab-3"> Not Linked  &nbsp;<span class="primary--text">{{product_count.not_linked}}</span></v-tab>

      <v-tab href="#tab-4"> Created on Shopify  &nbsp;<span class="primary--text">{{product_count.created_on_shopify}}</span></v-tab>
      <v-tab href="#tab-5"> Needs Attention  &nbsp;<span class="primary--text">{{product_count.need_attention}}</span></v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item :key="0" value="tab-0">
        <all-etsy-products :search="search" @updateSearch="updateSearch" @count-updated="updateCountValue"></all-etsy-products>
      </v-tab-item>

      <v-tab-item :key="1" value="tab-1">
        <linked-products :search="search" @updateSearch="updateSearch" @count-updated="updateCountValue"></linked-products>
      </v-tab-item>

      <v-tab-item :key="2" value="tab-2">
        <sku-linked-products :search="search" @updateSearch="updateSearch" @count-updated="updateCountValue"></sku-linked-products>
      </v-tab-item>

      <v-tab-item :key="3" value="tab-3">
        <not-linked-products :search="search" @updateSearch="updateSearch" @count-updated="updateCountValue"></not-linked-products>
      </v-tab-item>

      <v-tab-item :key="4" value="tab-4">
        <created-on-shopify :search="search" @updateSearch="updateSearch" @count-updated="updateCountValue"></created-on-shopify>
      </v-tab-item>
      <v-tab-item :key="5" value="tab-5">
        <needs-attention :search="search" @updateSearch="updateSearch" @count-updated="updateCountValue"></needs-attention>
      </v-tab-item>
    </v-tabs-items>
    <!-- </v-card> -->
  </div>
</template>

<script>
import AllEtsyProducts from './AllEtsyProducts.vue'
import LinkedProducts from './LinkedProducts.vue'
import SkuLinkedProducts from './SkuLinkedProducts.vue'
import NotLinkedProducts from './NotLinkedProducts.vue'
import CreatedOnShopify from './CreatedOnShopify.vue'
import NeedsAttention from './NeedsAttention.vue'
import store from '@/store'
import axios from 'axios'

export default {
  components: {
    AllEtsyProducts,
    SkuLinkedProducts,
    LinkedProducts,
    NotLinkedProducts,
    CreatedOnShopify,
    NeedsAttention,
  },
  data() {
    return {
      product_count: {
        all: 0,
        linked_product: 0,
        linked_sku: 0,
        created_on_shopify: 0,
        not_linked: 0,
        need_attention: 0,
      },
      tab: null,
      search: "",
      loadingProductCounts: false,
      productCountsDialog: false,
      productCounts: {
        count_by_state: {},
        total_count: 0
      },
      shop: null
    }
  },
  mounted() {
    this.shop = store.getters.loggedInShop
  },
  methods: {
    updateCountValue(new_count) {
      this.product_count = new_count;
    },
    updateSearch(newSearch) {
      this.search = newSearch;
    },
    async fetchRealTimeProductCounts() {
      try {
        this.loadingProductCounts = true;
        const response = await axios.get(`/admin/shops/${this.shop.id}/get-etsy-product-counts`);
        
        if (response.data && response.data.success) {
          this.productCounts = response.data;
          this.productCountsDialog = true;
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: response.data.message || 'Failed to fetch product counts',
          });
        }
      } catch (error) {
        console.error('Error fetching product counts:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch product counts',
        });
      } finally {
        this.loadingProductCounts = false;
      }
    },
    formatState(state) {
      // Format the state string to be more readable
      if (!state) return 'Unknown';
      
      // Convert to lowercase and capitalize first letter
      state = state.toLowerCase().replace(/_/g, ' ');
      return state.charAt(0).toUpperCase() + state.slice(1);
    },
  },
}
</script>

<style scoped>
.v-data-table >>> th {
  font-weight: bold;
}
</style>